// Realtime handles freshness — stale times only gate refetch on window focus.
export const PR_V2_SUMMARY_STALE_TIME_MS = 60_000;

// Most supporting datasets can be reused between realtime invalidations.
export const PR_V2_STANDARD_STALE_TIME_MS = 120_000;
